<h2 mat-dialog-title>
  {{ (input.product$ | async)?.name }}
  <span>{{ input.package?.volume?.value | number: '1.3-3' }} {{ input.package?.volume?.uom | translate }}</span>
  <span>{{ input.package?.pieces?.value }} {{ input.package?.pieces?.uom | translate }}</span>
</h2>

<div mat-dialog-content class="mat-dialog-content">
  <div class="package-wrapper">
    <app-package-card [package]="input.package" [cart]="input.cart" [internalUser]="input.internalUser" [currency]="input.currency"></app-package-card>
  </div>

  <section class="form">
    <div class="price" *ngIf="input.internalUser">
      <span>{{ 'PACK_LIST.LABEL_ENTER_PRICE' | translate }}</span>
      <mat-form-field appearance="legacy">
        <input matInput [(ngModel)]="pkg.selectedPrice" type="number" name="{{pkg.id}}-price" [min]="50" [max]="2000" step="1">
        <span matSuffix>{{ input.currency }}</span>
        <mat-hint *ngIf="!validPrice(pkg.selectedPrice)">{{ 'CART.TEXT_VALIDATION_PRICE_RANGE' | translate:{min:minPrice, max:maxPrice} }}</mat-hint>
      </mat-form-field>
    </div>
    <div class="cert" *ngIf="!pkg?.certificateCode">
      <span>{{ 'FILTER.TITLE_CERTIFICATES' | translate }}</span>
      <mat-radio-group [(ngModel)]="pkg.selectedCert" class="narrow">
        <mat-radio-button class="plain" *ngFor="let cert of codesApiService.certificates$ | async" [value]="cert.value">
          {{ 'CERTIFICATE.' + cert.value | translate }}
        </mat-radio-button>
      </mat-radio-group>
    </div>
  </section>

  <section class="actions">
    <button mat-flat-button class="deselect" (click)="deselect()">{{ 'PACK_LIST.ACTION_DESELECT' | translate }}</button>
    <div class="right">
      <button mat-flat-button (click)="close()">{{ 'PACK_LIST.ACTION_CANCEL' | translate }}</button>
      <button mat-button class="large" cdkFocusInitial (click)="save()">{{ 'PACK_LIST.ACTION_SAVE' | translate }}</button>
    </div>
  </section>
</div>
